"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapUserProfileToUserSearchItem = exports.mapAgentToUserItem = void 0;
const mapAgentToUserItem = (agent) => ({
    id: agent.id,
    birthday: agent.birthday,
    city: agent.city,
    name: agent.displayName,
    userType: 'agent',
});
exports.mapAgentToUserItem = mapAgentToUserItem;
const mapUserProfileToUserSearchItem = (item) => {
    var _a;
    return ({
        id: item.id,
        name: item.displayName,
        userType: (_a = item.type) !== null && _a !== void 0 ? _a : undefined,
        city: item.city,
        birthday: item.birthday,
    });
};
exports.mapUserProfileToUserSearchItem = mapUserProfileToUserSearchItem;
//# sourceMappingURL=utils.js.map